import { MAuthConfig } from '@mercadona/core/auth';
import { MLoggerLevel } from '@mercadona/core/logger';
import { MPlatformEnvironment } from '@mercadona/core/platform';
import { MTelemetryConfig, MTraces } from '@mercadona/core/telemetry';
import { MEnviroment } from '@mercadona/core/utils/environment';

/**
 * Do not duplicate this file into environment.dev.ts, environment.itg.ts, ...
 * Define here ONLY localhost environment variables.
 */
/**
 * For dev,itg,pre,pro environments copy this content to the chart files
 * charts/env/values-<env>.yaml
 */
const localEnvironment = {
  production: false,
  logLevel: MLoggerLevel.TRACE,
  env: 'local' as MPlatformEnvironment,
  debug: false,
  lang: 'es',
  api: {
    url: 'https://anual-resource.pre.mercadona.com', // Para mockoon -> /api
    scope: ['openid'],
    resource: 'api://mercadona/audience/services/anual/v1'
  },
  resources: {
    url: '/resources'
  },
  configToken: {
    clientId: '75c9cbf9-7f2d-4de5-b5da-a24cf6207206',
    authority: 'https://fed.premercadona.com/adfs',
    knownAuthorities: ['https://fed.premercadona.com/adfs'],
    resource: 'api://mercadona/audience/services/anual/v1',
    scope: ['openid'],
    postLogoutRedirectUri: 'http://localhost:4200/',
    redirectUri: 'http://localhost:4200/anual',
    authOnAppStart: true,
    navigateToLoginRequestUrl: true,
    passwordless: false
  } as MAuthConfig,
  telemetryConfig: {
    url: 'https://otelcol-front.pre.gcp.mercadona.com/v1/traces',
    traces: MTraces.DEFAULT
  } as MTelemetryConfig
};

const envInstance = new MEnviroment('anual-front-main', localEnvironment);

export const environment = envInstance.environment;
